import { Component, OnDestroy, OnInit } from "@angular/core";
import { PopupVisibility }              from "../../../@models/core";
import { Problem }                      from "../../../../shared-gen/Machine/Problem";
import { OpState }                      from "../../../../shared-gen/Machine/Status/OpState";
import { StatusListener }               from "../../../status-listener";
import { AppStatus }                    from "../../../@models/app-status";
import { AppService }                   from "../../../services/app.service";

@Component({
	selector: "kkb-tur-warning-panel",
	templateUrl: "./tur-warning-panel.component.html",
	styleUrls: ["./tur-warning-panel.component.scss", "../../../pages/tur/tur.scss"]
})
export class TurWarningPanelComponent extends StatusListener implements OnInit, OnDestroy {

	visibility: PopupVisibility = "";
	sensors: string[][] = [];

	private requestOpenTimer = 0;
	private sensorTimer = 0;

	problems: Problem[] = [];
	opState = OpState.Offline;
	message: string = null;
	problemsSet = false;

	constructor(app: AppService) {
		super(app);
	}

	open() {
		this.visibility = "popupVisible";
	}

	close() {
		this.visibility = "popupHidden";
	}

	cancelRequestOpen() {
		if (this.requestOpenTimer !== 0) {
			clearTimeout(this.requestOpenTimer);
			this.requestOpenTimer = 0;
		}
	}

	onStatusChanged(status: AppStatus) {
		super.onStatusChanged(status);
		const ms = status.deviceStatus.MachineStatus;
		this.opState = ms.OpState;
		this.problems = ms.Problems;
		this.message = ms.Message;
	}

}
